module.exports = __webpack_public_path__ + "media/images/escudo_gris-2acd1a328ab7452b00d7da5895245066.svg";